import { DefaultFileHandler } from './default-file-handler.js';
class FileService {
    constructor() {
        this.fileHandlersProviders = new Map();
        this.fileHandler = new DefaultFileHandler();
    }
    /**
     * @deprecated in favor of FileService.getFileHandlerInstance('handler-provider-name').download('/path');
     */
    download(endpoint, name, parameters, method, options) {
        return this.fileHandler.download(endpoint, name, parameters, method, options);
    }
    /**
     * @deprecated in favor of FileService.getFileHandlerInstance('handler-provider-name');
     */
    getFileHandler() {
        return this.fileHandler;
    }
    getFileHandlerInstance(providerName = '') {
        const provider = this.fileHandlersProviders.get(providerName);
        if (!provider) {
            throw new Error(`[File Service]: ${providerName} handler provider is not registered`);
        }
        const handler = provider();
        return handler;
    }
    /**
     * @deprecated in favor of FileService.getFileHandlerInstance('handler-provider-name').getPreviewURL('/path');
     */
    getPreviewURL(path) {
        return this.fileHandler.getPreviewURL(path);
    }
    /**
     * @deprecated in favor of FileService.getFileHandlerInstance('handler-provider-name').preview('/path');
     */
    preview(path) {
        this.fileHandler.preview(path);
    }
    /**
     * @deprecated in favor of FileService.getFileHandlerInstance('handler-provider-name').upload(file);
     */
    upload(file, events, maxFileSize) {
        return this.fileHandler.upload(file, events, maxFileSize);
    }
    registerFileHandlerProvider(params) {
        if (this.fileHandlersProviders.has(params.name)) {
            throw new Error(`[File Service]: ${params.name} handler provider is already registered`);
        }
        this.fileHandlersProviders.set(params.name, params.provider);
    }
    /**
     * @deprecated in favor of FileService.getFileHandlerInstance('handler-provider-name').remove('/path', 'file01', onExecuteRemove);
     */
    remove(path, name, onExecuteRemove) {
        this.fileHandler.remove(path, name, onExecuteRemove);
    }
    /**
     * @deprecated in favor of FileService.registerFileHandlerProvider('handler-provider-name');
     */
    setFileHandler(fileHandler) {
        this.fileHandler = fileHandler;
    }
}
const instance = new FileService();
export { instance as FileService, };
//# sourceMappingURL=file-service.js.map